export const LEAD_MANAGE_GET_LEADS_STATUS = 'LEAD_MANAGE_GET_LEADS_STATUS';
export const LEAD_MANAGE_GET_LEADS_STATUS_SUCCESS = 'LEAD_MANAGE_GET_LEADS_STATUS_SUCCESS';
export const LEAD_MANAGE_GET_LEADS_STATUS_FAILURE = 'LEAD_MANAGE_GET_LEADS_STATUS_FAILURE';

export const LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST = 'LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST';
export const LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_SUCCESS = 'LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_SUCCESS';
export const LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_FAILURE = 'LEAD_MANAGE_CHANGE_LEADS_STATUS_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/lead_manage_leads_status.constants.js